/* eslint-disable react/button-has-type */
import React, { useEffect, useState } from 'react';
import { RouteComponentProps } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { GetTitle } from './boardTitle';
import { getBreadScrumb } from './breadscrumb';
import { GetTableFooter } from '../../_component/tableFooter';
import server from '../../_api/backend';
import * as toast from '../../_store/slice/toast';

export function BooksAll(routeProps: RouteComponentProps) {
  const dispatch = useDispatch();
  let currentPage = 1;
  const [listItem, setListItem] = useState<any>();
  const [mainCategoriesName, setMainCategoriesName] = useState(
    new Map<string | undefined, string>()
  );
  const [subCategories, setSubCategories] = useState(new Map<string | undefined, string>());
  const [subCategoriesName, setSubCategoriesName] = useState(new Map<string | undefined, string>());

  useEffect(() => {
    getCategories();
    getItems();
  }, []);
  const getCategories = async () => {
    await server
      .getCategories()
      .then((payload) => {
        if (!payload) {
          dispatch(toast.error({ message: '서버로부터 응답이 없습니다.' }));
        } else if (payload.code === 260 || payload.code === 500) {
          dispatch(toast.error({ message: '파라미터 오류' }));
        } else {
          const main = new Map<string | undefined, string>();
          for (let i = 0; i < payload?.length; i++) {
            main.set(payload[i].id, payload[i].name);

            for (let j = 0; j < payload[i]?.children?.length; j++) {
              subCategories.set(payload[i]?.children[j].id, payload[i].id);
              subCategoriesName.set(payload[i]?.children[j].id, payload[i]?.children[j].name);
            }
          }
          setMainCategoriesName(main);
        }
      })
      .catch((error) => {
        dispatch(toast.error({ message: '서버 접속이 원활하지 않아 잠시 뒤에 시도해 주세요.' }));
        console.log(error);
      });
  };

  const getItems = async () => {
    await server
      .AllBookList(currentPage, 10)
      .then((payload) => {
        if (!payload) {
          dispatch(toast.error({ message: '서버로부터 응답이 없습니다.' }));
        } else if (payload.code === 260 || payload.code === 500) {
          dispatch(toast.error({ message: '파라미터 오류' }));
        } else {
          setListItem(payload);
        }
      })
      .catch((error) => {
        dispatch(toast.error({ message: '서버 접속이 원활하지 않아 잠시 뒤에 시도해 주세요.' }));
        console.log(error);
      });
  };

  const onClickDetail = (id: number) => {
    routeProps.history.push(`/books/${id}`);
  };

  const getList = (item: any) => {
    return (
      <>
        {item?.items?.map((it: any) => (
          <ul className="row" key={Math.random()}>
            <li className="categories">
              {`${mainCategoriesName.get(
                subCategories.get(it.categoryId)
              )} > ${subCategoriesName.get(it.categoryId)}`}
            </li>
            <li className="book-title" onClick={() => onClickDetail(it.id)}>
              {it.name}
            </li>
            <li className="author">{it.author}</li>
            <li className="day">{new Date(it.publicationDate).toLocaleDateString()} </li>
            <li className="price">{Number(it.priceFull).toLocaleString()}</li>
          </ul>
        ))}
      </>
    );
  };
  return (
    <div className="content">
      {getBreadScrumb('도서목록 전체보기')}
      {GetTitle(
        '',
        '도서목록 전체보기',
        '도서출판 구민사의 도서 전체 목록입니다. 해당 도서를 선택하시면 자세한 정보를 볼 수 있습니다.',
        '',
        '',
        false,
        () => {},
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        (param: string) => {},
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        (param: string) => {}
      )}

      <div className="table-header" />
      <div className="table">
        <ul className="row title">
          <li className="categories">위치</li>
          <li className="book-title">도서명</li>
          <li className="author">저자</li>
          <li className="day">발행정보</li>
          <li className="price">가격</li>
        </ul>
        {getList(listItem)}
      </div>
      {GetTableFooter(
        listItem?.meta.currentPage,
        listItem?.meta.totalPages,
        (page: number) => {
          currentPage = page;

          getItems();
        },
        '도서목록 다운로드',
        () => {},
        false
      )}
    </div>
  );
}
